// extracted by mini-css-extract-plugin
export var tallyIframe = "tally-module--tallyIframe--4a3c5";